const config = {

    namespaced: true,

    state: () => ({

        sidebarWidth: 16.6,
        packageVersion: JSON.parse(unescape(process.env.PACKAGE_JSON || '%7Bversion%3A0%7D')).version,
        routeTo: null,
        reasons: [
			{
				id: 'S',
				name: 'Holiday',
				czName: 'Svátek'
			},{
				id: 'D',
				name: 'Vacation',
				czName: 'Dovolená'
			},{
				id: 'NV',
				name: 'Time off in lieu',
				czName: 'Nahradní volno'
			},{
				id: 'SLC',
				name: 'Business trip',
				czName: 'Služební cesta'
			},{
				id: 'N',
				name: 'Sickdays',
				czName: 'Nemoc'
			},{
				id: 'OČR',
				name: 'Nursing a family member',
				czName: 'Ošetřování člena rodiny'
			},{
				id: 'P',
				name: 'Wedding, funeral, all-day doctor visit',
				czName: 'Svatba, pohřeb, celodenní návštěva lékaře'
			},{
				id: 'J',
				name: 'Other reasons',
				czName: 'Jiné důvody'
			}
		]

    }),

    mutations: {

        'SET_SIDEBAR_WIDTH' (state, width) {
			state.sidebarWidth = width
		},
        'SET_ROUTE' (state, data) {
			state.routeTo = data
		}

    }

}

export default config